import * as React from "react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { jsx } from "react/jsx-runtime";
//#region src/lib/utils.ts
function cn(...inputs) {
	return twMerge(clsx(inputs));
}
//#endregion
//#region src/components/Button.tsx
const variantStyles$1 = {
	default: "bg-blue-600 text-white hover:bg-blue-700",
	destructive: "bg-red-600 text-white hover:bg-red-700",
	outline: "border border-gray-300 bg-white text-gray-900 hover:bg-gray-50",
	ghost: "bg-transparent text-gray-900 hover:bg-gray-100"
};
const sizeStyles = {
	sm: "px-3 py-1.5 text-sm",
	md: "px-4 py-2 text-base",
	lg: "px-6 py-3 text-lg"
};
const Button = React.forwardRef(({ className, variant = "default", size = "md", ...props }, ref) => {
	return /* @__PURE__ */ jsx("button", {
		ref,
		className: cn("inline-flex items-center justify-center rounded-md font-medium transition-colors", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500", "disabled:opacity-50 disabled:pointer-events-none", variantStyles$1[variant], sizeStyles[size], className),
		...props
	});
});
Button.displayName = "Button";
//#endregion
//#region src/components/Badge.tsx
const variantStyles = {
	default: "bg-gray-100 text-gray-800",
	success: "bg-green-100 text-green-800",
	warning: "bg-yellow-100 text-yellow-800",
	danger: "bg-red-100 text-red-800",
	info: "bg-blue-100 text-blue-800"
};
function Badge({ className, variant = "default", ...props }) {
	return /* @__PURE__ */ jsx("span", {
		className: cn("inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold", variantStyles[variant], className),
		...props
	});
}
//#endregion
//#region src/components/Card.tsx
function Card({ className, ...props }) {
	return /* @__PURE__ */ jsx("div", {
		className: cn("rounded-lg border border-gray-200 bg-white shadow-sm", className),
		...props
	});
}
function CardHeader({ className, ...props }) {
	return /* @__PURE__ */ jsx("div", {
		className: cn("flex flex-col space-y-1.5 p-6", className),
		...props
	});
}
function CardTitle({ className, ...props }) {
	return /* @__PURE__ */ jsx("h3", {
		className: cn("text-lg font-semibold leading-none tracking-tight", className),
		...props
	});
}
function CardContent({ className, ...props }) {
	return /* @__PURE__ */ jsx("div", {
		className: cn("p-6 pt-0", className),
		...props
	});
}
//#endregion
export { Badge, Button, Card, CardContent, CardHeader, CardTitle, cn };

//# sourceMappingURL=index.js.map